
































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import "vue-slider-component/dist-css/vue-slider-component.css";
import "vue-slider-component/theme/default.css";
import { AxiosResponse } from "axios";
import { SetAutomaticPayload } from "../types";

const Subscription = namespace("subscriptions");
@Component({})
export default class AdditionalFeaturesPanel extends Vue {
  @Subscription.Action("setAutomaticSetting") setAutomaticSetting!: (
    payload: SetAutomaticPayload
  ) => Promise<AxiosResponse>;
  @Subscription.Action("getCurrentVendorQuota")
  getCurrentVendorQuota!: () => Promise<AxiosResponse>;
  @Subscription.Getter("isPepEnabled") isPepEnabled!: boolean;
  @Subscription.Getter("isSanctionEnabled") isSanctionEnabled!: boolean;
  @Subscription.Getter("isKybEnabled") isKybEnabled!: boolean;

  features = [
    {
      id: "pep",
      title: "PEP Compliance Scans",
    },
    {
      id: "sanctions",
      title: "Sanction Compliance Scans",
    },
    {
      id: "company_compliance",
      title: "Organisation Compliance Scans (KYB)",
    },
  ];

  loading = false;

  isChecked(id) {
    if (id === "pep") {
      return this.isPepEnabled;
    } else if (id === "sanctions") {
      return this.isSanctionEnabled;
    } else if (id === "company_compliance") {
      return this.isKybEnabled;
    }
  }

  async applyChanges(id: string, event, title) {
    this.loading = true;
    const action = event.target.checked ? "enable" : "disable";
    await this.setAutomaticSetting({ id, enabled: event.target.checked })
      .then(() => {
        this.$notify({
          group: "success",
          title: "Success",
          text: `${this.capitalizeFirstLetter(action)}d automatic ${title}`,
        });
      })
      .catch(() => {
        this.$notify({
          group: "error",
          title: "Error",
          text: `Failed to ${action} automatic ${title}`,
        });
      });
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
